export const COUNT = 'COUNT';
export const MY_TRIP_ID = 'trips_sitewide';
export const DEFAULT_TIMEOUT = 10000;
export const IDP_APP = 'MY_TRIPS';
export const TRIPS_REQUEST = 'trips_request';
export const SEARCH_REQUEST = 'trip_request';
export const TRIP_DETIALS_URL = '/my-trips/trip-details';
export const UPCOMING_TRIPS_URL = '/my-trips/upcoming-trips';
export const SEARCH_TRIPS_URL = '/my-trips/search?errorCodes=';
